import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'timeStringToNumber'
})
export class TimeStringToNumberPipe implements PipeTransform {

  transform(timeInMinutes: string): number {
    let ret: number = null;

    if (timeInMinutes !== null && timeInMinutes !== '') {
      const hh: string = timeInMinutes.split(':')[0];
      const mm: string = timeInMinutes.split(':')[1];

      const hours: number = parseInt(hh, 10);
      const minutes: number = parseInt(mm, 10);

      ret = hours * 60 + minutes;
    }

    return ret;
  }

}
